import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { IconButton, Typography, Box } from "@material-ui/core";
import { Save, Edit } from "@material-ui/icons";
import PropTypes from "prop-types";
import moment from "moment";

import { useStyles } from "./DatePicker.styles";
import { dateFormatNoTime, dateFormatMui } from "../../_constants";

const DatePicker = ({
  title,
  onSave,
  dateValue = null,
  emptyLabel,
  isEditEnabled,
}) => {
  const classes = useStyles();

  const [isEditing, setEditing] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const save = () => {
    setEditing(false);
    let parsedDate = moment(selectedDate).valueOf();
    onSave({ deadlineDateInMillis: parsedDate });
  };

  return (
    <>
      {isEditing ? (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid className={classes.wrapper}>
            <KeyboardDatePicker
              className={classes.placeholder}
              disableToolbar
              autoOk
              variant="inline"
              format={dateFormatMui}
              margin="normal"
              id="date-picker-inline"
              label={title}
              value={selectedDate}
              onChange={handleDateChange}
              emptyLabel={emptyLabel}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
            {isEditEnabled ? (
              <Save
                className={[classes.saveicon, classes.pointer].join(" ")}
                onClick={save}
              ></Save>
            ) : (
              ""
            )}
          </Grid>
        </MuiPickersUtilsProvider>
      ) : (
        <Grid>
          <Box display="flex" flexDirection="column">
            <Box>
              <Typography variant="body1" className={classes.inputLabel}>
                {title}
              </Typography>
            </Box>
            <Box display="flex" flexDirection="row">
              {dateValue === null ? (
                <Typography variant="body1" className={classes.value}>
                  {emptyLabel}
                </Typography>
              ) : (
                <Typography variant="body1" className={classes.value}>
                  {moment(dateValue).format(dateFormatNoTime)}
                </Typography>
              )}
              {isEditEnabled ? (
                <IconButton
                  className={[classes.iconAlign, classes.pointer].join(" ")}
                  onClick={() => {
                    if (dateValue !== null) {
                      const d = moment(dateValue).format(dateFormatNoTime);
                      setSelectedDate(d);
                    }
                    setEditing(true);
                  }}
                  data-testId="select-date-btn"
                >
                  <Edit className={classes.editicon} />
                </IconButton>
              ) : (
                ""
              )}
            </Box>
          </Box>
        </Grid>
      )}
    </>
  );
};

DatePicker.propTypes = {
  title: PropTypes.string,
  onSave: PropTypes.func,
  dateValue: PropTypes.any,
  hasValue: PropTypes.bool,
  emptyLabel: PropTypes.string,
  isEditEnabled: PropTypes.bool,
};

export { DatePicker };
